import { gql } from '@apollo/client'

export default gql(`
query batchGetMedia($input: [ID]){
    batchGetMedia(
        input: $input
    ){
        id
        type
        name
    }
}`)
